export function LoadingSkeleton({
  lines = 3,
  className = "",
}: {
  lines?: number
  className?: string
}) {
  return (
    <div className={`animate-pulse space-y-3 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="h-4 bg-slate-200 rounded"
          style={{ width: `${70 + Math.random() * 30}%` }}
        />
      ))}
    </div>
  )
}

export function CardSkeleton({ className = "" }: { className?: string }) {
  return (
    <div className={`bg-white p-4 rounded-lg shadow-sm animate-pulse ${className}`}>
      <div className="h-2.5 bg-slate-200 rounded w-24 mb-3" />
      <div className="h-6 bg-slate-200 rounded w-16 mb-2" />
      <div className="h-2 bg-slate-200 rounded w-20" />
    </div>
  )
}

export function TableSkeleton({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <div className="animate-pulse">
      <div className="h-10 bg-slate-100 rounded mb-1" />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4 py-3 border-b border-slate-100">
          {Array.from({ length: cols }).map((_, j) => (
            <div
              key={j}
              className="h-4 bg-slate-200 rounded flex-1"
            />
          ))}
        </div>
      ))}
    </div>
  )
}
